import * as React from 'react';
import { Markdown } from '../Markdown/index.js';
export var ChatItem = function (_a) {
    var owner = _a.owner, content = _a.content;
    var variant = owner !== 'self' ? 'incoming' : 'outgoing';
    return (React.createElement("div", { className: "chat-message-container ".concat(variant) },
        React.createElement(Markdown, { className: "chat-message ".concat(variant), md: content })));
};
//# sourceMappingURL=ChatMessage.js.map